import React, { useEffect, useCallback, useMemo } from "react";
import { Row } from "antd";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import Layout from "../../../components/Layout";
import noDataLogo from "../../../assets/images/no-data.png";
import { customBaseUrl, httpGet } from "../../../store/http";
import { useMatStyles } from "./style";
import { hideLoader, showLoader } from "../../../utils/loader";

const BonusEarned = () => {
  const navigate = useNavigate();
  const [pagination, setPagination] = React.useState({
    current: 0,
    pageSize: 10,
  });
  const styles = useMatStyles();
  const [allTransfers, setAllTransfers] = React.useState(0);
  const [allTransactions, setAllTransactions] = React.useState([]);

  const getTransactions = useCallback(async (page, size) => {
    setAllTransactions([]);
    showLoader();
    const pages = page ?? pagination.current;
    const limit = size ? size : pagination.pageSize;

    let request = await httpGet(
      `${customBaseUrl.referralUrl}/api/v1/admin/get-users-bonus-earnings?page=${pages}&size=${limit}`
    );

    if (request.status) {
      setAllTransactions(request.data.users || []);
      setAllTransfers(request.data.totalItems || 0);
    }
    hideLoader();
  }, [pagination.current, pagination.pageSize]);

  useEffect(() => {
    getTransactions();
  }, [getTransactions]);

  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
    await getTransactions(0, value);
  };

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
    await getTransactions(newPage, pagination.pageSize);
  };

  const columns = useMemo(() => [
    {
      field: 'userId',
      headerName: 'Full Name',
      width: 250,
      headerClassName: styles.tableHeader,
    },
    {
      field: "amount",
      headerName: "Amount",
      width: 250,
      headerClassName: styles.tableHeader,
    },
    {
      field: 'status',
      headerName: "Status",
      width: 150,
      headerClassName: styles.tableHeader,
    },
    {
      field: 'created_at',
      headerName: "Date created",
      width: 150,
      headerClassName: styles.tableHeader,
    }
  ], [styles.tableHeader]);

  return (
    <Layout>
      <div
        style={{ cursor: "pointer", marginBottom: "20px" }}
        onClick={() => navigate("/users/referral")}
      >
        <span className="me-1">
          <ArrowLeftOutlined />
        </span>
        back
      </div>

      {allTransactions?.length > 0 ? (
        <div style={{ height: 800, width: "100%" }}>
          <DataGrid
            getRowId={row => row.userId || row.id}
            className={styles.table}
            density="comfortable"
            rows={allTransactions}
            columns={columns}
            page={pagination.current}
            pageSize={pagination.pageSize}
            onPageSizeChange={handleChangeRowsPerPage}
            onPageChange={handleChangePage}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            pagination
            components={{ Toolbar: GridToolbar }}
            rowCount={allTransfers}
          />
        </div>
      ) : (
        <>
          <Row
            type="flex"
            justify="center"
            align="middle"
            className="mt-5"
            style={{ minHeight: "40vh" }}
          >
            <img src={noDataLogo} alt="nodata" style={{ height: "300px" }} />
          </Row>
          <h4 className="mt-3 text-center">No Request yet</h4>
          <p className="mt-3 text-center" style={{ color: '#8C8C8C' }}>
            Request will appear here when you have transactions
          </p>
        </>
      )}
    </Layout>
  );
};

export default BonusEarned;
